module.exports = __webpack_public_path__ + "static/media/app_store.bc11fe07.svg";